const LOCAL_SETTINGS = [
  {
    id: 'decimalFormat',
    type: 'optionlist',
    label: 'Darstellung Arbeitszeiten',
    description: 'Arbeitszeiten können im Dezimal- oder Stunden- und Minutenformat angezeigt werden.',
    structure: [
      {
        id: 'decimal',
        label: 'Arbeitszeiten werden im Dezimalformat (z.B. 4,90 h entsprechen 4 Stunden und 54 Minuten) angezeigt.',
      },
      {
        id: 'hours_and_minutes',
        label: 'Arbeitszeiten werden im Stunden- und Minutenformat (z.B. 4:54 h entsprechen 4 Stunden und 54 Minuten) angezeigt.',
      },
    ],
    default: 'hours_and_minutes',
  }
];

function retrieveSetting(id: string) {
  const value = JSON.parse(localStorage.localSettings || '{}')[id];
  if (value) return value;

  return LOCAL_SETTINGS.filter(d => d.id == id)[0].default;
}

function updateSetting(id: string, newValue: string) {
  const settings = JSON.parse(localStorage.localSettings || '{}');
  settings[id] = newValue;
  localStorage.localSettings = JSON.stringify(settings);
}

export { LOCAL_SETTINGS, retrieveSetting, updateSetting };
